export const ID_TOKEN_KEY = 'pona_app_id_token'
export const ACCESS_TOKEN_KEY = 'pona-token'
export const REFRESH_TOKEN_KEY = 'pona-refresh-token'
export const USER_ID_KEY = 'pona_app_user_id'

export const handlePrivateRoutes = (to, from, next) => {
  if (isLoggedIn()) return next()
  else next({ path: '/login' })
}

export const setAccessTokens = (token, refreshToken) => {
  if (token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token)
  }

  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  }
}

export const getAccessTokens = () => {
  return {
    token: localStorage.getItem(ACCESS_TOKEN_KEY),
    refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY)
  }
}

export const setUserId = userId => {
  return localStorage.setItem(USER_ID_KEY, userId)
}

export const getUserId = () => {
  return localStorage.getItem(USER_ID_KEY)
}

export const isLoggedIn = () => !!getUserId()

export const logIn = ({ token, refreshToken, userId }) => {
  setAccessTokens(token, refreshToken)
  setUserId(userId)
}

export const logOut = () => {
  localStorage.clear()
  import('./graph/apollo').then(({ apolloClient }) => apolloClient.clearStore())
}
